import { RewardType } from "@/types/teamRanking";
const isWeb = true;
const isMRN = false;
import { getAppVersion, getPlatformType, isWeixinMiniProgramOrWeixinWebview, PlatformType } from "@nibfe/mkt-env-api";
import { setClipboardData } from '@max/meituan-uni-clipboard';
export const convertCentsToYuan = (cents, fixed = 1) => {
    if (typeof cents !== 'number' || isNaN(cents)) {
        return {
            integerPart: '',
            decimalPart: ''
        };
    }
    const yuan = (cents / 100).toFixed(fixed); // 将分转换为元，并保留一位小数
    const [integerPart, decimalPart] = yuan.split('.'); // 将元按照小数点分割成整数部分和小数部分
    return {
        integerPart,
        decimalPart,
        str: `${integerPart}.${decimalPart}`
    };
};
export const convertCentsToYuan2 = (cents, fixed = 1) => {
    if (typeof cents !== 'number' || isNaN(cents)) {
        return {
            integerPart: '',
            decimalPart: ''
        };
    }
    // 避免四舍五入，使用向下取整
    const multiplier = Math.pow(10, fixed);
    const yuan = Math.floor(cents / 100 * multiplier) / multiplier;
    const yuanStr = yuan.toFixed(fixed);
    const [integerPart, decimalPart] = yuanStr.split('.');
    return {
        integerPart,
        decimalPart,
        str: `${integerPart}.${decimalPart}`
    };
};
/**
 * 将分转换为元，只取整数部分
 * @param cents 分数
 * @returns 元的整数部分
 */
export const convertCentsToYuanInteger = (cents) => {
    if (typeof cents !== 'number' || isNaN(cents)) {
        return '';
    }
    return Math.floor(cents / 100);
};
export const MTfinStyle = {
    fontFamily: isMRN ? 'MTfin-Regular2.0' : 'MTfin-Regular2'
};
export const MTNewDigitalDisplayStyle = isMRN && compareVersion(getAppVersion(), '12.33.400') === 0 ? {} : {
    fontFamily: 'MTNewDigitalDisplay-Bold'
};
export function appendParams(url, params) {
    // 分离 hash 部分
    const [baseUrlWithQuery, hash] = url.split('#');
    const [baseUrl, queryString] = baseUrlWithQuery.split('?');
    // 解析现有查询参数
    const queryParams = queryString ? queryString.split('&') : [];
    const existingParams = {};
    queryParams.forEach(pair => {
        const [key, value] = pair.split('=');
        existingParams[decodeURIComponent(key)] = decodeURIComponent(value);
    });
    // 合并新参数
    const combinedParams = Object.assign(Object.assign({}, existingParams), params);
    // 构建新的查询字符串
    const newQueryString = Object.entries(combinedParams).map(([key, value]) => `${encodeURIComponent(key)}=${encodeURIComponent(value)}`).join('&');
    // 拼接最终的 URL
    return `${baseUrl}?${newQueryString}${hash ? `#${hash}` : ''}`;
}
export const getQueryParams = (ctx) => {
    const params = {};
    if (isWeb) {
        const queryString = window.location.search.substring(1);
        const queryArray = queryString.split('&');
        queryArray.forEach(query => {
            const [key, value] = query.split('=');
            params[key] = decodeURIComponent(value);
        });
        //  params['cityId'] = params['cityId'] || ctx._runtimeInfo.queryParams?.cityId;
    }
    // console.log('params:========= ',isWeb, params);
    return params;
};
export function extendArray(data, expectedLength = 3) {
    // 如果数组长度已经大于等于5，直接返回
    if (data.length >= expectedLength || data.length === 0) {
        return data;
    }
    // 计算需要重复的次数
    const repeatCount = Math.ceil(expectedLength / data.length);
    // 创建一个新数组，包含重复的原数组
    const result = [];
    for (let i = 0; i < repeatCount; i++) {
        result.push(...data);
    }
    return result;
}
export function formatDate(ts) {
    if (!ts) {
        ts = Date.now();
    }
    const date = new Date(ts);
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    return {
        slashStr: `${year}/${month}/${day}`,
        dashStr: `${year}-${month}-${day}`,
        hanStr: `${year}年${month}月${day}日`
    };
}
export function lessThan(value, base) {
    if (typeof value !== 'number' || isNaN(value)) {
        return false;
    }
    if (typeof base !== 'number' || isNaN(base)) {
        return false;
    }
    return value < base;
}
export function isValidRewardType(rewardType) {
    return rewardType === RewardType.FREE_CARD || rewardType === RewardType.POINTS;
}
export function compareVersion(v1, v2) {
    const arr1 = v1.split('.');
    const arr2 = v2.split('.');
    const len = Math.max(arr1.length, arr2.length);
    while (arr1.length < len) {
        arr1.push('0');
    }
    while (arr2.length < len) {
        arr2.push('0');
    }
    for (let i = 0; i < len; i++) {
        const num1 = parseInt(arr1[i]);
        const num2 = parseInt(arr2[i]);
        if (num1 > num2) {
            return 1;
        }
        else if (num1 < num2) {
            return 0;
        }
    }
    return 1;
}
;
export function getRandomTag(groupIdSeed) {
    try {
        let hash = Math.abs(groupIdSeed);
        hash = hash * 1103515245 + 12345;
        hash = hash / 65536 % 32768;
        hash = hash ^ hash >> 16;
        hash = hash * 0x85ebca6b;
        hash = hash ^ hash >> 13;
        hash = hash * 0xc2b2ae35;
        hash = hash ^ hash >> 16;
        hash = Math.abs(hash);
        const tags = ['最近活跃', '黑马', '战力满满', '潜力股', '虚位以待', 'Call值飙升', 'Call值新星', '超有冲劲', '团结小队'];
        const index = hash % tags.length;
        return tags[index];
    }
    catch (error) {
        return '最近活跃';
    }
}
/**
 * 判断给定的 URL 是否为 H5 页面的 URL
 * @see https://sky.sankuai.com/docs/nibfe/platform-common-api-repository/
 */
export const isH5URL = (url) => {
    return Boolean(url && url.indexOf('http') === 0);
};
export const convertLinkToAppMiddleOpenLink = (url) => {
    return `https://m.dianping.com/awp/hfe/block-page/call-native/meituan.html?url=${encodeURIComponent(url)}`;
};
const CLIPBOARD_SCENE_TOKEN = 'dd-45211aae3c95c761';
// 复制文字
export const copyText = (text, onSuccess, onFail) => {
    if (text) {
        setClipboardData({
            data: text,
            _meituan: {
                androidToast: true,
                sceneToken: CLIPBOARD_SCENE_TOKEN
            },
            _wechat: {
                _mt: {
                    sceneToken: CLIPBOARD_SCENE_TOKEN
                }
            },
            _web: {
                webToast: true,
                sceneToken: CLIPBOARD_SCENE_TOKEN
            }
        }).then(() => {
            onSuccess && onSuccess();
        }).catch(() => {
            onFail && onFail();
        });
    }
    else {
        onFail && onFail();
    }
};
export function getTeamRankingSource() {
    const platfromType = getPlatformType();
    let teamRankingSource = null;
    switch (platfromType) {
        case PlatformType.mtApp:
        case PlatformType.mtAppWebView:
            teamRankingSource = 'mt';
            break;
        case PlatformType.dpApp:
        case PlatformType.dpAppWebView:
            teamRankingSource = 'dp';
            break;
        case PlatformType.mtMinaWebview:
            teamRankingSource = 'mt_mini';
            break;
        case PlatformType.mtHotelMinaWebview:
            teamRankingSource = 'mt_hotel_mini';
            break;
        case PlatformType.dpMinaWebview:
            teamRankingSource = 'dp_mini';
            break;
        default:
            break;
    }
    if (!teamRankingSource) {
        if (isWeixinMiniProgramOrWeixinWebview()) {
            teamRankingSource = 'wx_h5';
        }
        else {
            teamRankingSource = 'unknown';
        }
    }
    return teamRankingSource;
}
